module.exports = __webpack_public_path__ + "img/specif_eng.ae428581.jpg";